import { useAppSelector } from "@/shared/lib/redux"
import { MarketplaceCard } from "@/shared/ui/marketplace-card"
import { useNavigate } from "react-router-dom"
import { Loader } from "@/shared/ui/loader"
import ArrowUpRightSvg from '@/shared/assets/images/ArrowUpRight.svg'
import { selectSocialMarketFoundations, selectSocialMarketFoundationsLoading } from "../../model"

export const FoundationsGrid = () => {
    const foundations = useAppSelector(selectSocialMarketFoundations)
    const foundationsLoading = useAppSelector(selectSocialMarketFoundationsLoading)
    const navigate = useNavigate()

    return (
        <>
            {Boolean(foundations.length) &&
                <div className="grid grid-cols-12 gap-[10px] auto-rows-fr">
                    {foundations.map(foundation =>
                        <div key={foundation.id} className="col-span-6 lg:col-span-4 xxl:col-span-4 screen:col-span-3">
                            <MarketplaceCard
                                image={foundation.logo}
                                title={(
                                    <div className="flex items-center gap-2 justify-between">
                                        <div className="overflow-ellipsis overflow-hidden">
                                            {foundation.name}
                                        </div>
                                        <div className="shrink-0">
                                            <a href={foundation.href} className="text-color-primary">
                                                <ArrowUpRightSvg width={24} height={24} />
                                            </a>
                                        </div>
                                    </div>
                                )}
                                subtitle={"Проверенный фонд"}
                                description={(
                                    <div className="flex flex-col h-full">
                                        <div title={foundation.description} className="max-h-[200px] w-full line-clamp-6 text-ellipsis h-full">
                                            {foundation.description}
                                        </div>
                                        <div className="text-color-primary mt-5 hover:underline">
                                            <a href={foundation.href} target="_blank">{foundation.href}</a>
                                        </div>
                                    </div>
                                )}
                                buttonText={"Перейти"}
                                onClick={() => navigate(`/social-market/partners/${foundation.id}`)}
                            />
                        </div>
                    )}
                </div>
            }
            {(!Boolean(foundations.length) && foundationsLoading) &&
                <Loader />
            }
            {(!Boolean(foundations.length) && !foundationsLoading) &&
                <div className="h-full flex items-center justify-center">
                    <div className="font-mediumttf -mt-[150px] bg-color-secondary rounded-2xl screen:rounded-3xl text-white py-6 px-8 text-2xl text-center">
                        НЕТ ДАННЫХ О <br /> ФОНДАХ
                    </div>
                </div>
            }
        </>
    )
}